import {
  Box,
  Center,
  Text,
  Button,
  Modal,
  ModalHeader,
  ModalCloseButton,
  Flex,
  ModalOverlay,
  ModalContent,
  Input,
  ModalBody,
  Textarea,
  useDisclosure
} from '@chakra-ui/react'
import { FC } from 'react'

import useFollowUpAlert from '@base/hooks/alerts/use-followup'
const ModalComment: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { handleUpdateEditParams, paramsEdit, sendComments } =
    useFollowUpAlert()
  return (
    <>
      <Button
        height="38px"
        colorScheme="primary"
        variant="outline"
        onClick={onOpen}
      >
        Comentar
      </Button>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="lg"
      >
        <ModalOverlay />
        <ModalContent
          background={'white'}
          marginLeft={[4, 8, 16]}
          marginRight={[4, 8, 16]}
        >
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex alignItems="center">
              <Text marginLeft={2}>Adicionar Comentarios</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody bg="white" pt={0} py={4}>
            <Box p={4}>
              <Text fontWeight="bold">Total Selecionados: 1</Text>
            </Box>
            <Box p={4}>
              <Text mb="8px">Data de Solução da Ação</Text>
              <Input
                type="date"
                borderBottomColor="black"
                placeholder=""
                size="sm"
                value={paramsEdit.date}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'date',
                    value: value.target.value
                  })
                }
              />
            </Box>
            <Box p={4}>
              <Text mb="8px">Comentario</Text>
              <Textarea
                placeholder=""
                size="sm"
                borderBottomColor="black"
                value={paramsEdit.coment}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'coment',
                    value: value.target.value
                  })
                }
              />
            </Box>
            <Center>
              <Box p={2} alignItems="center" alignContent="center">
                <Button
                  colorScheme="green"
                  mr={3}
                  onClick={() => {
                    onClose()
                    sendComments()
                  }}
                  alignItems="center"
                >
                  Salvar
                </Button>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                  Fechar
                </Button>
              </Box>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ModalComment
